<div class="container-fluid p-0 settings-page user-management-page">
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="show_assistant = true"
    />

    <section class="container-fluid px-4 py-4">
        <SettingsUserManagementTab :user_profile="user_profile" />
    </section>

    <BolideAssistant :is_open="show_assistant" @close-assistant="show_assistant = false" />
</div>
